import { Injectable, Inject } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CornerstoneService {
  constructor(private api: ApiService) {}

  gotoCornerstone(url?: string): Observable<any> {
    return this.api.get(`employee/api/v1/Cornerstone/cornerstone?url=${url}`);
  }

  gotoCornerstoneText(url?: string): Observable<string> {
    const encoded = url ? encodeURIComponent(url) : '';
    return this.api.getText(`employee/api/v1/Cornerstone/cornerstone?url=${encoded}`);
  }
}
